import Chip from "components/Chip";
import { EnergyAnalysisSettingsGroup } from "features/energy-analysis-dashboard/components/EnergyAnalysisSettingsGroup";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styling";

import type { CrremPathwayCorrectionOption } from "../model/types";

import { correctionFlagCount, correctionOptionOrder } from "../model/constants";

type CrremPathwayCorrectionControlProps = {
  onChange: (ids: string[]) => void;
  options: CrremPathwayCorrectionOption[];
  value: string[];
};

export const CrremPathwayCorrectionControl = ({ onChange, options, value }: CrremPathwayCorrectionControlProps) => {
  const { t } = useTranslation();
  if (options.length === 0) return null;
  return (
    <EnergyAnalysisSettingsGroup iconName="Sun" label={t("BuildingProfile.energyAnalysis.settings.corrections")}>
      <div className="w-110 grid min-w-0 grid-cols-3 gap-1">
        {options
          .slice()
          .sort((left, right) => correctionOptionOrder(left.corrections) - correctionOptionOrder(right.corrections))
          .map((option) => (
            <Chip
              className={cn(
                "w-full min-w-0 !font-ds-body-regular-xxs",
                correctionFlagCount(option.corrections) === 3 && "col-span-3"
              )}
              isOn={value.includes(option.id)}
              key={option.id}
              onClick={() =>
                onChange(value.includes(option.id) ? value.filter((id) => id !== option.id) : [...value, option.id])
              }
            >
              {option.label}
            </Chip>
          ))}
      </div>
    </EnergyAnalysisSettingsGroup>
  );
};
